import { render, staticRenderFns } from "./DidsInfoTable.vue?vue&type=template&id=986153a4&"
import script from "./DidsInfoTable.vue?vue&type=script&lang=ts&"
export * from "./DidsInfoTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports